module.exports = __webpack_public_path__ + "media/images/career_camp/2023/perks_3-1b012c6e9a64a6a4711c990010372040.svg";